import {getLastMessage} from './UserDialogPreviewHelper'

export default getLastMessage
